import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Staff } from 'src/app/model/user/staff.model';
import { ImportStaff } from 'src/app/model/user/staff-personnel-import';

@Injectable({ providedIn: 'root' })
export class StaffService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8'
    })
  };
  version = 'v1.0';
  url = environment.apiUrl + this.version + '/DisStaffs';
  urlImg = environment.apiUrl + this.version + '/DisImgs';
  constructor(private http: HttpClient) {
  }

  get(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/Get?' + queryString);
  }

  getAllStaffBySystemUser(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/GetSelectPagingBySystemUser?' + queryString);
  }

  getAllStaffByStaffStudent(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/GetSelectPagingByStaffStudent?' + queryString);
  }

  GetSelectPagingNhanSuThuocCoSo(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/GetSelectPagingNhanSuThuocCoSo?' + queryString);
  }

  GetSelectPagingTheoQuyen(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/GetSelectPagingTheoQuyen?' + queryString);
  }

  getById(id: any): Observable<any> {
    return this.http.get(this.url + `/GetById/${id}`, this.httpOptions);
  }

  getImgById(id: any): Observable<any> {
    return this.http.get(this.urlImg + '/GetSelectPagingImg?AvatarUrl=' + id, this.httpOptions);
  }
  getImage(id: string): Observable<any> {
    return this.http.get(this.urlImg + '/GetSelectPagingImg?AvatarUrl=' + id);
    //.subscribe(base64data => {
    //   console.log(base64data);
    //   // this is the image as dataUrl
    //   return 'data:image/jpg;base64,' + base64data;
    // });
    //return this.http.get(this.urlImg +'/GetSelectPagingImg?AvatarUrl=' + id, {responseType: "blob"});
  }
  getSelectPaging(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/GetSelectPaging?' + queryString);
  }

  getSelectPagingTeacher(filter: any): Observable<any> {
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/GetSelectPagingByTeacher?' + queryString);
  }

  addOrUpdate(model): Observable<any> {
    if (typeof model.yearOfBirth === "object") {
      model.yearOfBirth = model.yearOfBirth.getFullYear();
    }
    if (model.id == 0 || model.id == undefined) {
      return this.http.post(this.url + '/Add', model, this.httpOptions);
    } else {
      return this.http.put(this.url + `/Update/${model.id}`, model, this.httpOptions);
    }
  }

  delete(id: number): Observable<any> {
    return this.http.delete(this.url + `/Delete/${id}`, this.httpOptions);
  }

  deleteMulti(listId: number[]): Observable<any> {
    return this.http.post(this.url + `/DeleteMulti`, listId, this.httpOptions);
  }

  importAvata(file: any): Observable<any> {
    let formData = new FormData();
    formData.append('files', file, file.name);
    return this.http.post(this.url + `/UploadAvata`, formData);
  }

  importNhanSu(file: File, importStaff: any): Observable<any> {
    let fileImport: File = file;
    let formData = new FormData();
    formData.append('file', fileImport, fileImport.name);
    let queryString = Object.keys(importStaff).map(key => key + '=' + importStaff[key]).join('&');
    return this.http.post(this.url + `/GetSelectPagingImport?` + queryString, formData);
  }

  downloadTemplate(): Observable<any> {
    return this.http.get(this.url + '/GetSelectPagingDownloadTemplates', { responseType: 'blob' as 'json' });
  }
  downloadTemplateGV(): Observable<any> {
    return this.http.get(this.url + '/GetSelectPagingDownloadGVTemplates', { responseType: 'blob' as 'json' });
  }
  downloadTemplateNVTL(): Observable<any> {
    return this.http.get(this.url + '/GetSelectPagingDownloadNVTLTemplates', { responseType: 'blob' as 'json' });
  }

  exportExcel(filter: any): Observable<any> {
    filter = JSON.parse(JSON.stringify(filter));
    delete filter.PageIndex; delete filter.PageSize;
    let queryString = Object.keys(filter).map(key => key + '=' + filter[key]).join('&');
    return this.http.get(this.url + '/GetSelectPagingExport?' + queryString, { responseType: 'blob' as 'json' });
  }
  getUrlImportAvatar() {
    return this.url + `/UploadAvata`;
  }
}
